<template>
  <div class="add-data">

    <el-dialog :closeOnClickModal='false' title="图书" :modal-append-to-body='false' :visible.sync="visible"
      width="800px">
      <div class="edit-context" style="min-width:650px;">

        <div class="edit-inp">

          <el-form :rules="rules" ref="form" :model="form" label-width="110px">

            <div class="item-box">
              <el-form-item v-for="(item,index) in formList" :key='index' :label="item.label" :prop="item.field">
                <el-input v-if="item.type=='input'" style="width:228px" v-model.trim="form[item.field]"
                  :placeholder="item.placeholder">
                </el-input>
                <el-select v-if="item.type=='option'" v-model.trim="form[item.field]" :placeholder="item.placeholder">
                  <el-option v-for="value in item.optionList" :key="value.id" :label="value.label" :value="value.value">
                  </el-option>
                </el-select>
                <el-cascader v-if="item.type=='cascader'" v-model.trim="form[item.field]" :props="defaultProps"
                  :options="item.optionList" :show-all-levels="false">
                </el-cascader>
              </el-form-item>
            </div>

            <el-form-item label="是否公开：" prop="openState">
              <el-radio-group v-model.trim="form.openState">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="附件上传：" style="padding-right:15px">

              <div class="upload-box">
                <el-upload class="upload-demo" :file-list='fileList' :before-upload='beforeUploadFile'
                  :auto-upload='true' action :http-request="uploadSectionFile" accept="application/pdf"
                  :on-remove="handleRemove" :limit="1" :on-exceed="handleExceed">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">文件只支持pdf格式，且不超过50MB，封面只支持jpg、jpeg和png格式，且不超过5M</div>
                </el-upload>

                <el-upload class="avatar-uploader" :before-upload='beforeUploadIcon' :auto-upload='true' action
                  :http-request="uploadSectionImg" :show-file-list="false" accept=".jpeg,.jpg,.png">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                    <div><span>封</span><span>面</span></div>
                  </i>
                </el-upload>
              </div>
            </el-form-item>

          </el-form>

          <div class="handleBtn">
            <button class="primary" @click.prevent="onSubmit(form)">确认</button>
            <button class="default" @click="closeBtn">取消</button>
          </div>
        </div>

        <div v-if="isPercentage" class="percentage-box">
          <el-progress color='#24ba58' type="circle" :percentage="percentageNum"></el-progress>
        </div>

      </div>

    </el-dialog>

  </div>
</template>

<script>
import utils from "@/util/index";
import {
  getDictTree,
  ossUpload,
  getUploadPolicies,
  addDigitalBook,
  setResource,
  getFileInfo
} from "@/network/resourceRequest/api";
import util from "@/util/index";
export default {
  name: "AddDigitalBooks",
  props: {
    selectDict: {
      default() {
        return {};
      }
    },
    form: {
      default() {
        return {
          name: "", //图书名称
          author: "", //作者
          edition: "", //出版社
          category: "", //分类
          language: "", //语种
          type: "", //图书类型
          toll: "", //是否收费
          openState: 1, //公开状态
          fileId: "", //文件id凭证
          fileIdList: [], //文件id列表
          coverId: "", //封面id凭证
          id: 0, //资源id
          label: "" //标签属性
        };
      }
    },
    //是否显示编辑或者添加弹窗--------------------------------------------
    centerDialogVisible: { default: false },

    //类型add set
    type: {},
    //编辑的数据
    rowData: {}
  },

  data() {
    return {
      //渲染表单列表
      formList: [
        {
          field: "name",
          type: "input",
          label: "图书名：",
          placeholder: "输入图书名"
        },
        {
          field: "author",
          type: "input",
          label: "作者：",
          placeholder: "输入作者名"
        },
        {
          field: "edition",
          type: "input",
          label: "出版社：",
          placeholder: "输入作者名"
        },
        {
          field: "category",
          type: "cascader",
          label: "分类：",
          placeholder: "请选择分类",
          optionList: []
        },
        {
          field: "language",
          type: "option",
          label: "语种：",
          placeholder: "请选择语种",
          optionList: [
            { value: "汉语", lable: "汉语" },
            { value: "英语", lable: "汉语" }
          ]
        },
        {
          field: "toll",
          type: "option",
          label: "授权：",
          placeholder: "请选择计费方式",
          optionList: [
            {
              value: 1,
              label: "免费"
            },
            {
              value: 2,
              label: "收费"
            }
          ]
        },
        {
          field: "type",
          type: "option",
          label: "类型：",
          placeholder: "请选择类型",
          optionList: [{ value: "图书", lable: "图书" }]
        }
      ],

      //级联选择器
      defaultProps: {
        children: "children",
        label: "value",
        emitPath: false
      },

      //表单校验规则
      rules: {},
      //旧的表单数据 用于判断表单是否更改过--------------------------------------------
      oldForm: {},
      //是否显示编辑或者添加弹窗--------------------------------------------
      visible: false,
      //文件回显用--------------------------------------------
      fileList: [],
      //上传的文件信息(用于获取)--------------------------------------------
      fileInfoList: [],
      //文件id列表--------------------------------------------
      fileIdList: [],
      //文件封面信息--------------------------------------------
      fileCoverList: [],
      //文件封面id列表--------------------------------------------
      fileCoverIdList: [],
      //封面回显--------------------------------------------
      imageUrl: "",
      //上传成功文件数
      uploadFileNum: [],
      //当前进度
      currentUploadList: [],

      //是否显示百分比状态
      isPercentage: false
    };
  },

  created() {
    //初始化数据
    this.init();
    //初始化校验规则
    this.checkRule();
  },

  watch: {
    //5.给后台明确添加成功
    uploadFileNum(newVal) {
      if (newVal.length != 0) {
        this.uploadedSuccessfully(newVal);
      }
    },

    centerDialogVisible(newValu) {
      this.visible = newValu;
    },

    visible(newVal) {
      this.$emit("update:centerDialogVisible", newVal);
      if (!newVal) {
        this.initFile();
      }
    },

    //编辑的数据--------------------------------------------
    rowData(row) {
      if (row) {
        //赋值旧的表单数据--------------------------------------------
        for (const key in this.form) {
          if (this.form.hasOwnProperty(key)) {
            this.oldForm[key] = this.form[key];
          }
        }
        this.imageUrl = row.coverPath;
        let ids = { ids: row.fileIdList.join() };
        getFileInfo(ids).then(res => {
          if (res.data.success) {
            this.fileList = [];
            res.data.data.forEach(item => {
              this.fileList.push({ name: item.filename });
            });
          }
        });
      }
    }
  },

  computed: {
    //进度条
    percentageNum() {
      let loaded = 0;
      let total = 0;
      this.currentUploadList.forEach(item => {
        loaded += item.loaded;
        total += item.total;
      });
      return ((loaded / total) * 100) | 0;
    }
  },

  methods: {
    init() {
      getDictTree({ type: "books_type" }).then(res => {
        if (res.data.success) {
          this.formList.forEach((item, index) => {
            if (item.field == "category") {
              this.$set(this.formList[index], "optionList", res.data.data);
            }
          });
        }
      });
    },

    //初始化文件
    initFile() {
      //文件回显用--------------------------------------------
      this.fileList = [];
      //上传的文件信息(用于获取)--------------------------------------------
      this.fileInfoList = [];
      //文件id列表--------------------------------------------
      this.fileIdList = [];
      //文件封面信息--------------------------------------------
      this.fileCoverList = [];
      //文件封面id列表--------------------------------------------
      this.fileCoverIdList = [];
      //封面回显--------------------------------------------
      this.imageUrl = "";
      //上传成功文件数
      this.uploadFileNum = [];
      //当前进度
      this.currentUploadList = [];
    },

    //初始化校验规则
    checkRule() {
      //校验名称
      let validateName = (rule, value, callback) => {
        if (value === "") {
          switch (rule.field) {
            case "name":
              callback(new Error("请输入图书名称"));
              break;
            case "author":
              callback(new Error("请输入作者名称"));
              break;
            case "edition":
              callback(new Error("请输入出版社"));
              break;
          }
        } else {
          callback();
        }
      };

      //提示规则  //下拉选择框可以默认选择第一个
      this.rules = {
        name: [{ required: true, validator: validateName, trigger: "blur" }],
        author: [{ required: true, validator: validateName, trigger: "blur" }],
        edition: [{ required: true, validator: validateName, trigger: "blur" }],
        category: [
          { required: true, message: "请选择分类", trigger: "change" }
        ],
        language: [
          { required: true, message: "请选择语种", trigger: "change" }
        ],
        toll: [
          { required: true, message: "请选择授权方式", trigger: "change" }
        ],
        openState: [
          { required: true, message: "请选择公开状态", trigger: "change" }
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }]
      };
    },

    //表单校验是否通过--------------------------------------------
    formVerification(form) {
      let falg = "";
      this.$refs.form.validate(valid => {
        if (valid) {
          falg = true;
        } else {
          falg = false;
        }
      });
      return falg;
    },

    //关闭窗口按钮--------------------------------------------
    closeBtn() {
      this.$emit("update:centerDialogVisible", false);
    },

    //上传前文件校验--------------------------------------------
    beforeUploadFile(file) {
      let fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let fileNameLength = file.name.length; //取到文件名长度
      let fileFormat = file.name.substring(fileName + 1, fileNameLength); //截取
      switch (fileFormat) {
        case "pdf":
        case "PDF":
          break;
        default:
          utils.tips("warning", "非法类型，只支持pdf");
          return false;
          break;
      }
      if (file.size / 1024 / 1024 > 50) {
        utils.tips("warning", "文件大小不能超过50M");
        return false;
      }
    },

    //上传前封面校验--------------------------------------------
    beforeUploadIcon(file) {
      let fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let fileNameLength = file.name.length; //取到文件名长度
      let fileFormat = file.name.substring(fileName + 1, fileNameLength); //截取
      switch (fileFormat) {
        case "jpg":
        case "JPG":
        case "JPEG":
        case "jpeg":
        case "png":
        case "PNG":
          break;
        default:
          utils.tips("warning", "非法类型，封面只支持jpg、jpeg、png格式");
          return false;
          break;
      }

      if (file.size / 1024 / 1024 > 5) {
        utils.tips("warning", "封面大小不能超过5M");
        return false;
      }
    },

    //1.自定义上传文件功能（获取文件信息）--------------------------------------------
    uploadSectionFile(params) {
      let data = {
        filename: params.file.name, //文件名,
        size: params.file.size, //文件大小
        space: "RESOURCE", //文件存储空间,可选:RESOURCE,COMMON,ICON
        file: params.file,
        params
      };
      this.fileInfoList = [];
      this.fileInfoList.push(data);
    },

    //1.自定义上传图片功能（获取图片信息）--------------------------------------------
    uploadSectionImg(params) {
      //获取文件路径
      this.imageUrl = window.URL.createObjectURL(params.file);

      let data = {
        filename: params.file.name, //文件名,
        size: params.file.size, //文件大小
        space: "COMMON", //文件存储空间,可选:RESOURCE,COMMON,ICON
        file: params.file,
        params
      };

      this.fileCoverList = [];
      this.fileCoverList.push(data);
    },

    //2.确定上传--------------------------------------------
    onSubmit(form) {
      //校验表单是否通过再去上传
      let flag = this.formVerification(form);
      if (flag) {
        //添加时
        if (this.type == "add") {
          //上传文件;
          if (this.fileInfoList.length == 0)
            return utils.tips("warning", "请您添加文件");
          if (this.fileCoverList.length == 0)
            return utils.tips("warning", "请您添加封面");
          this.uploadFile();
        }

        //当编辑时
        if (this.type == "set") {
          //当文件不修改时，需判断表单信息是否变更--------------------------------------------
          if (
            this.checkFormChanges() &&
            this.fileList.length != 0 &&
            this.fileInfoList.length == 0 &&
            this.fileCoverList.length == 0
          ) {
            utils.tips("error", "信息未修改");
            return;
          }
          //文件删除后--------------------------------------------
          if (this.fileList.length == 0 && this.fileInfoList.length == 0) {
            utils.tips("error", "请添加文件");
            return;
          }

          if (this.fileInfoList.length + this.fileCoverList.length == 0) {
            this.uploadedSuccessfully();
          } else {
            this.uploadFile();
          }
        }
      } else {
        utils.tips("warning", "请您完善信息");
      }
    },

    //编辑时检验表单是否更改--------------------------------------------
    checkFormChanges() {
      let flag = true;
      for (const key in this.form) {
        if (
          this.form.hasOwnProperty(key) &&
          key != "fileId" &&
          key != "fileIdList" &&
          key != "coverId"
        ) {
          if (this.form[key] != this.oldForm[key]) {
            flag = false;
          }
        }
      }
      return flag;
    },

    //3.上传文件--------------------------------------------
    uploadFile() {
      //展示加载进度
      this.isPercentage = true;

      // 上传文件--------------------------------------------
      this.fileInfoList.forEach(item => {
        this.currentUploadList.splice(0, 1, { loaded: 0, total: 0 });
        this.getPolicie(item, "file", 0);
      });

      //上传图片--------------------------------------------
      this.fileCoverList.forEach(item => {
        this.currentUploadList.splice(1, 1, { loaded: 0, total: 0 });
        this.getPolicie(item, "picture", 1);
      });
    },

    //4.获取上传凭证--------------------------------------------
    async getPolicie(data, type, index) {
      //获取凭证--------------------------------------------
      let policie = await getUploadPolicies(data);
      let result = policie.data.data;
      let fd = new FormData();
      fd.append("key", result.path); //
      fd.append("OSSAccessKeyId", result.accessid); //
      fd.append("policy", result.policy); //
      fd.append("signature", result.signature); //签名
      fd.append("success_action_status", 200); //
      fd.append("file", data.file); //
      // 上传阿里云--------------------------------------------;
      ossUpload(result.host, fd, this.uploadCallback, index).then(res => {
        //上传阿里云成功后--------------------------------------------
        if (res.status == 200) {
          switch (type) {
            //文件--------------------------------------------
            case "file":
              // 文件列表id
              this.fileIdList.push(result.fileId);
              // 文件id
              this.$set(this.form, "fileId", this.fileIdList[0]);
              //上传成功的数组--------------------------------------------
              this.uploadFileNum.push(result.fileId);
              break;

            //封面--------------------------------------------
            case "picture":
              // 文件封面列表id
              this.fileCoverIdList.push(result.fileId);
              // 文件封面id
              this.$set(this.form, "coverId", this.fileCoverIdList[0]);
              //上传成功的数组--------------------------------------------
              this.uploadFileNum.push(result.fileId);
              break;
          }
        } else {
          console.log("AddETextBook=>上传阿里云失败");
        }
      });
    },

    //上传回调--------------------------------------------
    uploadCallback(progressEvent, index) {
      let uploadData = {
        loaded: progressEvent.loaded,
        total: progressEvent.total
      };
      this.currentUploadList.splice(index, 1, uploadData);
    },

    //删除文件--------------------------------------------
    handleRemove(file) {
      this.fileInfoList.forEach((item, index) => {
        if (item.file.uid == file.uid) {
          this.fileInfoList.splice(index, 1);
          this.$set(this.form, "fileId", this.fileInfoList[0]);
        }
      });

      this.fileList = [];
    },

    //限制上传的文件数量--------------------------------------------
    handleExceed(files, fileList) {
      utils.tips("warning", `只能上传一个文件`);
    },

    //跟后台确定上传成功
    uploadedSuccessfully(newVal) {
      //当没上传文件时进来
      if (this.fileInfoList.length + this.fileCoverList.length == 0) {
        if (this.type == "set") {
          setResource("books", this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "修改成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }
        return;
      }
      //当上传成功的数量等于文件和封面的数量时  提交给后台说明图书添加成功
      if (
        newVal.length ==
        this.fileInfoList.length + this.fileCoverList.length
      ) {
        this.$set(this.form, "fileIdList", this.fileIdList);
        if (this.type == "add") {
          addDigitalBook(this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "上传成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }

        if (this.type == "set") {
          setResource("books", this.form).then(res => {
            if (res.data.success) {
              //关闭加载进度
              this.isPercentage = false;
              utils.tips("success", "修改成功");
              //关闭窗口
              this.closeBtn();
              this.$emit("addSuccess");
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.add-data {
  user-select: none;
  position: relative;
  width: 100%;
  .percentage-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.2);

    /deep/ .el-progress__text {
      color: #24ba58 !important;
    }
  }

  /deep/ .el-dialog {
    overflow: hidden;

    border-radius: 5px;

    // 头部
    .el-dialog__header {
      padding: 20px;

      background-color: #24ba58;

      .el-dialog__title {
        color: #fff;

        user-select: none;
      }

      .el-dialog__close {
        font-size: 20px;

        color: #fff;
      }
    }

    //内容
    .el-dialog__body {
      .item-box {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
          width: 50%;
        }
      }

      .upload-box {
        .avatar-uploader .el-upload {
          overflow: hidden;

          position: relative;

          border: 1px dashed #d9d9d9;
          border-radius: 6px;

          cursor: pointer;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          position: relative;

          width: 100px;
          height: 100px;

          font-size: 28px;
          line-height: 100px;
          text-align: center;

          color: #8c939d;

          div {
            display: flex;

            position: absolute;
            top: 0;
            left: 0;

            padding-left: 4px;
            width: 100%;

            letter-spacing: 5px;

            justify-content: space-between;
          }
        }
        .avatar {
          display: block;

          width: 100px;
          height: 100px;
        }
      }
    }

    .handleBtn {
      display: flex;

      align-items: center;
      justify-content: center;

      button {
        margin: 0 100px;
        border: 1px solid #24ba58;
        border-radius: 5px;
        width: 80px;
        height: 40px;

        font-size: 14px;
        line-height: 40px;
        text-align: center;
        letter-spacing: 5px;

        color: #fff;
        background-color: #24ba58;

        outline: none;

        transition: all 0.3s;

        cursor: pointer;

        &:hover {
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

          transform: translateY(-1px);
        }
      }
    }
  }
}
</style>